import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PatientRoutingModule } from './patient-routing.module';
import { UpdatePatientComponent } from './pages/update-patient/update-patient.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';
import { MatButtonModule } from '@angular/material/button';
import { BirthDateConfirmPatientModalComponent } from './pages/birth-date-confirm-patient-modal/birth-date-confirm-patient-modal.component';


@NgModule({
  declarations: [
    UpdatePatientComponent,
    BirthDateConfirmPatientModalComponent
  ],
  imports: [
    CommonModule,
    PatientRoutingModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class PatientModule { }
